import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faClock, faArrowLeft, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import SEO from '../SEO/SEO';

const BlogPost = ({
                      title,
                      subtitle,
                      category,
                      categoryIcon,
                      color = '#7030A0',
                      date,
                      readTime,
                      image,
                      imageAlt,
                      imageCaption,
                      ctaHeading,
                      ctaText,
                      seoDescription,
                      seoKeywords,
                      slug,
                      children
                  }) => (
    <>
        <SEO
            title={`${title} | Nebulyx AI Blog`}
            description={seoDescription || subtitle || title}
            keywords={seoKeywords || `AI, ${category}, Nebulyx`}
            canonicalUrl={`https://nebulyx.ai/blog/${slug}`}
            ogType="article"
        />

        <article className="blog-post-page">
            {/* Hero */}
            <header className="blog-post-hero">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <Link to="/blog" className="blog-post-back">
                                <FontAwesomeIcon icon={faArrowLeft} /> All articles
                            </Link>

                            <div>
                                <span className="blog-post-category" style={{ background: color + '12', color: color }}>
                                    {categoryIcon && <FontAwesomeIcon icon={categoryIcon} className="me-1" />}
                                    {category}
                                </span>
                            </div>

                            <h1 className="blog-post-title">{title}</h1>

                            {subtitle && (
                                <p className="blog-post-subtitle">{subtitle}</p>
                            )}

                            <div className="blog-post-meta">
                                <span>
                                    <FontAwesomeIcon icon={faCalendarDays} className="me-1" style={{ color: color }} />
                                    {date}
                                </span>
                                <span>
                                    <FontAwesomeIcon icon={faClock} className="me-1" style={{ color: color }} />
                                    {readTime}
                                </span>
                                <span className="blog-post-author">Jon Cooke, Founder &amp; CEO</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </header>

            {/* Featured image */}
            {image && (
                <div className="blog-post-image-wrapper">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <img src={image} alt={imageAlt || title} className="blog-post-image" />
                                {imageCaption && (
                                    <p className="blog-post-image-caption">{imageCaption}</p>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}

            {/* Body */}
            <div className="blog-post-body">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            {children}
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Footer CTA */}
            <div className="blog-post-cta">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} className="text-center">
                            <h3>{ctaHeading || 'Want to see this in action?'}</h3>
                            <p>{ctaText || "Book a 30-minute discovery call. We'll show you a working AI pilot for your use case."}</p>
                            <a
                                href="https://cal.eu/jon-cooke/discovery-call"
                                className="btn btn-primary btn-lg cta-button"
                            >
                                Book Discovery Call
                            </a>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Back to blog */}
            <div className="blog-post-footer">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} className="d-flex justify-content-between align-items-center">
                            <Link to="/blog" className="blog-post-back">
                                <FontAwesomeIcon icon={faArrowLeft} /> Back to all articles
                            </Link>
                            <a
                                href="https://www.linkedin.com/company/nebulyx-ai"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="blog-post-share"
                                style={{ color: color }}
                            >
                                Follow on LinkedIn <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '0.7rem' }} />
                            </a>
                        </Col>
                    </Row>
                </Container>
            </div>
        </article>
    </>
);

export default BlogPost;